import { createApi } from "@reduxjs/toolkit/query/react";
import { ICreateLinkBody, ICreateLinkResponse } from "types/branch";

import { baseQueryWithIntercept } from "../connection/api";

const ENDPOINT_PREFIX = "branch";

export const branchApi = createApi({
    reducerPath: "branchApi",
    baseQuery: baseQueryWithIntercept,
    endpoints: build => ({
        createBranchLink: build.mutation<ICreateLinkResponse, ICreateLinkBody>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}/create-branch-link`,
                method: "POST",
                body: data.data,
            }),
        }),
    }),
});

export const {
    useCreateBranchLinkMutation,
} = branchApi;
